import React, { useEffect, useState } from "react";
import axios from "axios";
import { csSession } from "../auth/session";

const API = "https://mototaksi.az";

export default function CSuccess() {
  const [loading, setLoading] = useState(true);
  const [sub, setSub] = useState(null);
  const [err, setErr] = useState(null);
  const [msg, setMsg] = useState("Yoxlanılır...");

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const phone = csSession.getPhone();

        if (!phone) {
          setErr("Telefon tapılmadı. Zəhmət olmasa yenidən daxil olun.");
          setLoading(false);
          return;
        }

        // 8 dəfə yoxla (təxminən 12 saniyə)
        for (let i = 0; i < 8; i++) {
          const res = await axios.get(
            `${API}/api/me/subscription?phone=${encodeURIComponent(phone)}`
          );

          if (cancelled) return;

          const subData = res.data?.data || null;
          setSub(subData);

          const isActive =
            subData?.status === "ACTIVE" ||
            subData?.active === true ||
            subData?.isActive === true;

          if (isActive) {
            setMsg("Abunəlik aktivdir. Yönləndirilirsiniz...");
            // istəsən avtomatik dashboard:
            window.location.replace("/couriersub/dashboard");
            return;
          }

          setMsg("Ödəniş qeydə alınır... (bir neçə saniyə)");
          await new Promise((r) => setTimeout(r, 1500));
        }

        // hələ ACTIVE olmadısa
        setMsg("Ödəniş yenilənir. Dashboard-a keçib yeniləyə bilərsiniz.");
      } catch (e) {
        setErr("Abunəlik yoxlanıla bilmədi (yenilə).");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => { cancelled = true; };
  }, []);

  return (
    <div style={{ maxWidth: 520, margin: "40px auto", padding: 16 }}>
      <h2>✅ Ödəniş uğurludur</h2>

      {loading ? (
        <p>{msg}</p>
      ) : err ? (
        <p style={{ color: "red" }}>{err}</p>
      ) : (
        <>
          <p>{msg}</p>

          {sub && (
            <div style={{ marginTop: 12, padding: 12, border: "1px solid #ddd", borderRadius: 10 }}>
              <div><b>Status:</b> {sub.status}</div>
              <div><b>Plan:</b> {sub.plan}</div>
              <div><b>Növbəti ödəniş:</b> {sub.currentPeriodEnd || "-"}</div>
            </div>
          )}

          <a href="/couriersub/dashboard" style={{ display: "inline-block", marginTop: 16 }}>
            Dashboard-a keç
          </a>
        </>
      )}
    </div>
  );
}

